var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/store/slices/userListSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
var initialState = {
    list: [],
    user: null,
    total_records: 0,
    records_per_page: 10,
    pages: 0,
    user_exist_in_chaselist: false,
    draw: 0,
    recordsTotal: 0,
    recordsFiltered: 0,
    loading: false,
    errors: null,
};
var requestPayload = {
    search: '',
    page: 1,
    start: 10,
    length: 10,
    draw: 0,
    subtractDays: 0,
};
// Create an async thunk for fetching the user list
export var fetchUserList = createAsyncThunk('userList/fetchUserList', function (params, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                requestPayload.page = params.page;
                return [4 /*yield*/, axios.post('chaselist/listyesterday', requestPayload)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_1 = _a.sent();
                if (axios.isAxiosError(error_1) && error_1.response) {
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_1.response.data.errors)];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue({ general: 'An unknown error occurred' })];
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); });
var userListSlice = createSlice({
    name: 'userList',
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder
            .addCase(fetchUserList.pending, function (state) {
            if (requestPayload.page === 1)
                state.loading = true;
            state.errors = null;
        })
            .addCase(fetchUserList.fulfilled, function (state, action) {
            if (requestPayload.page === 1)
                state.list = action.payload.list;
            else
                state.list = __spreadArray(__spreadArray([], state.list, true), action.payload.list, true);
            state.user = action.payload.user;
            state.total_records = action.payload.total_records;
            state.records_per_page = action.payload.records_per_page;
            state.pages = action.payload.pages;
            state.user_exist_in_chaselist = action.payload.user_exist_in_chaselist;
            state.draw = action.payload.draw;
            state.recordsTotal = action.payload.recordsTotal;
            state.recordsFiltered = action.payload.recordsFiltered;
            state.loading = false;
        })
            .addCase(fetchUserList.rejected, function (state, action) {
            state.loading = false;
            state.errors = action.payload;
        });
    },
});
export default userListSlice.reducer;
